import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { ProjectDeveloperAnalytics } from '@/components/analytics/ProjectDeveloperAnalytics';

const ProjectAnalytics = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">Project Developer - Analytics</h1>
          <p className="text-muted-foreground">
            Comprehensive analytics dashboard for project developers
          </p>
        </div>
        <ProjectDeveloperAnalytics />
      </div>
    </MainLayout>
  );
};

export default ProjectAnalytics;